import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { EventWithLabel } from '~shared/modules/seo/constants';

export class GATrackingSeoFaqToggleEvent implements GATrackingEvent {
  constructor(private payload: EventWithLabel) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SeoFaqToggle;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.SeoFaqToggle,
      label: this.payload.label,
    };
  }
}
